import { useQuery } from '@tanstack/react-query'
import { supabaseApi } from '~/supabase/api'

export const GET_ALL_MODELS_QUERY_KEY = 'get-all-models'

export const useGetAllModels = () => {
  return useQuery({
    queryKey: [GET_ALL_MODELS_QUERY_KEY],
    queryFn: async () => {
      const { data, error } = await supabaseApi
        .from('models_v2')
        .select('*, suppliers ( full_name )')
        .neq('status', 'deprecated')
        .order('id', { ascending: false })

      if (!data && error) throw error

      return data
    },
  })
}
